import { jsx } from "react/jsx-runtime";
import { ListItem as MUIListItem } from "@mui/material";
import { forwardRef } from "react";
const ListItemInner = ({ ...restProps }, ref) => {
  return /* @__PURE__ */ jsx(
    MUIListItem,
    {
      ...restProps,
      ref
    }
  );
};
const ListItem = forwardRef(ListItemInner);
export {
  ListItem
};
